import SubTopics from "components/SubTopics/SubTopics";


const SubTopicsPage: React.FC = () => {
  return <SubTopics />;
};
  
export default SubTopicsPage;